import { constants } from 'helpers'

const {
  EVENT_CONSTANTS: { STATUS },
} = constants

export const getTicketPriceString = ticketPrice => !!ticketPrice && `$${ticketPrice} USD`

export const getNextChildEvent = event => {
  const activeEvent = event.series.find(
    childEvent =>
      [STATUS.CREATED || STATUS.STARTED].includes(childEvent.status) &&
      !childEvent.userSignedUpAlready &&
      !childEvent.ticketsHaveSoldOut
  )

  return activeEvent || event.series[event.series.length - 1]
}
